import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../i18n/LanguageContext";

function NotFound() {
  const { t } = useLanguage();

  return (
    <div className="not-found">
      <h1>{t("notFound.title")}</h1>
      <p>{t("notFound.text")}</p>
      <Link to="/" className="btn" style={{ marginTop: "1rem", display: "inline-block" }}>
        {t("notFound.backHome")}
      </Link>
    </div>
  );
}

export default NotFound;
